import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CommonModal from './CommonModal';

const PublishActivateDeactivateModal = ({
  sentData,
  onEvent,
  onConfirm,
  apiPath,
  axios,
  columnName,
  dbAction,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [t] = useTranslation();

  useEffect(() => {
    if (sentData && onEvent) {
      setShowModal(true);
    }
  }, [sentData, onEvent]);

  const handleCloseModal = () => {
    setShowModal(false);
    onEvent({ open: false, sentData: null });
  };

  const stateMappings = [
    {
      currentState: 'published_active',
      newState: 'published_deactivated',
      actionString: 'deactivate',
    },
    {
      currentState: 'not_published',
      newState: 'published_active',
      actionString: 'publish',
    },
    {
      currentState: 'published_deactivated',
      newState: 'published_active',
      actionString: 'activate',
    },
  ];

  const getStateMapping = (currentState) => {
    return (
      stateMappings.find(
        (mapping) => mapping.currentState === currentState
      ) || {
        newState: 'published_active',
        actionString: 'activate',
      }
    );
  };

  const toggleStatus = async (sentData) => {
    try {
      const { newState } = getStateMapping(sentData[dbAction]);
      await axios
        .patch(
          `/api/${apiPath}/${sentData.id}/publish`,
          {
            [dbAction]: newState,
          },
          { withCredentials: true }
        )
        .then((resp) => {
          setShowModal(false);
          toast.success('Status updated successfully', {
            position: 'top-center',
          });
          onConfirm(); // Call onConfirm to update the list
        })
        .catch((error) => {
          console.error('Error toggling status:', error);
          const msg = error.response?.data?.message;
          if (msg) {
            toast.error(msg, {
              position: 'top-center',
            });
          }
        });
    } catch (err) {
      console.error('Error toggling status:', err);
    }
  };

  const { actionString } = getStateMapping(sentData?.[dbAction]);

  return (
    <>
      <CommonModal
        open={showModal}
        message={`Are you sure you want to ${actionString} ${sentData?.[columnName]}?`}
        buttonProps={[
          { label: 'Cancel', onClick: handleCloseModal },
          { label: 'Confirm', onClick: () => toggleStatus(sentData) },
        ]}
        hideHeader
        id="hideHeader"
      />
    </>
  );
};

export default PublishActivateDeactivateModal;
